export const styles = {
	center: {
		justifyContent: 'center',
	},
	chip: {
		margin: '1.2rem',
		fontSize: '2rem',
		fontWeight: '500',
		color: '#000000DE',
		minHeight: '5.4rem',
		cursor: 'pointer',
		borderRadius: '10rem',
		'&&:hover, &&:focus': {
			color: 'white',
			background: '#0C4152',
		},
		background: 'linear-gradient(90deg, #9DCDF2 0%, #BDDEF6 100%)',
		borderColor: '#00000042',
		padding: '8px 16px 8px 16px',
	},
	gameCardBottomDivider: {
		borderWidth: '1px',
		width: '100%',
		borderColor: '#45657B',
		marginTop: {
			lg: '0px',
			sm: '0px',
			xs: '40px',
		},
	},
	gameCardContainer: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		width: '100%',
		alignItems: 'center',
	},
	gameCardContainerBaseGridItem: {
		margin: 'auto',
		display: 'flex',
		justifyContent: 'center',
	},
	gameCardContainerCardGridItem: {
		display: 'flex',
		marginBottom: {
			xs: '28px',
			sm: '85px',
		},
		transition: 'opacity 1.8s',
		justifyContent: {
			xs: 'center',
		},
	},
	filerLabel: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		fontSize: {
			lg: '20px',
			sm: '18px',
			xs: '16px',
		},
		color: '#000000DE',
		marginLeft: '2rem',
		marginRight: '2rem',
	},
	flexEnd: {
		justifyContent: 'flex-end',
	},
	flexStart: {
		justifyContent: 'flex-start',
	},
	gameCardContent: {
		maxWidth: '1260px',
	},
	homePage: {
		alignContent: 'center',
		alignItems: 'center',
		display: 'flex',
		gapRow: '10rem',
		flexDirection: 'column',
		height: '100%',
		marginBottom: { lg: '7rem', sm: '5rem', xs: '4rem' },
	},
	innerFiltersContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		whiteSpace: 'nowrap',
		marginBottom: '5rem',
		flexWrap: 'wrap',
	},
	opacity25: {
		opacity: '25%',
	},
	opacity100: {
		opacity: '100%',
	},
	outerFiltersContainer: {
		justifyContent: 'center',
		flexDirection: 'column',
	},
	subheader: {
		color: '#000000DE',
		fontSize: { sm: '3.3rem', xs: '2.2rem' },
		fontWeight: '400',
		textAlign: 'center',
		width: '100%',
	},
}
